const elements = {
  triggers: document.querySelectorAll('.js-navigation-dropdown-trigger'),
}

const active = 'is-active'

function toggleDropdown(e) {
  const container = e.target.closest('.js-navigation-dropdown');
  container.classList.toggle(active)
}

function init(){
  if(elements.triggers.length) {
    elements.triggers.forEach((trigger) => trigger.addEventListener('click', toggleDropdown));
  }
}

export default init;


// WEBPACK FOOTER //
// ./src/components/components/partnerhub/navigation-dropdown/navigation-dropdown.js